import { useState } from "react"
import { API_URL, GUEST, LOCAL_STORAGE_TOKEN, USER } from "../../constans/roles";
import InputText from "../../components/InputText/InputText";
import LabelSelect from "../../components/LabelSelect/LabelSelect";
import Button from "../../components/Button/Button";
import Header from "../Header/Header";


const Register = () => {
    const [email,setEmail] = useState("");
    const [password,setPassword] = useState("");
    const [role, setRole] = useState(GUEST);

    const handleEmail = (e) => {
        setEmail(e.target.value)
    }

    const handlePassword = (e) => {
        setPassword(e.target.value)
    }

    const handleRole = (e) => {
        setRole(e.target.value)
    }

    const handleRegister = async (e) => {
        e.preventDefault();

        let tmpArr = [GUEST]

        if(!email)
            return alert("NIe podano maila!")
        if(!password)
            return alert("NIe podano hasła!")
        if(!role)
            return alert("NIe podano roli!")


        if(role === 'user') {
            tmpArr = [GUEST,USER]
        }

        const response = await fetch( API_URL + '/api/user/register', {
            method: 'POST',
            
            headers: { 
                'Content-Type': 'application/json' ,
                "x-auth-token": localStorage.getItem(LOCAL_STORAGE_TOKEN)
            },
            body: JSON.stringify({
                login: email,
                password: password,
                role: tmpArr 
        })
    });

        const data = await response.json();
        if (response.ok) {
            alert('Dodano użytkownika!');
        } else {
            alert(data.message);
        }
    };

    return (
        <>
          <Header />
           <div className="register-wrapper" style={{height:'86vh'}}>
          

            <form className="register-form" onSubmit={handleRegister}>

                <InputText 
                    placeholder="Login"
                    value={email}
                    text="Login: "
                    name="mail"
                    handleChange={handleEmail}
                />

                <InputText 
                    placeholder="haslo"
                    value={password}
                    text="Hasło: "
                    name="haslo"
                    handleChange={handlePassword}
                />

                <LabelSelect 
                    options={
                        [
                            {value:GUEST,txt:"Gość"},
                            {value:USER,txt:"Grafik"}
                        ]
                    }
                    text="Rola: "
                    name="role"
                    handleChange={handleRole}
                />

                <Button 
                    txt="Dodaj"
                    click={handleRegister}
                    styles={{
                        width:'300px !important',
                        margin: '0',
                        backgroundColor:'black'
                    }}
                />
      

            </form>

                  <section className="register-right-section">
        <img
            src="./Images/logo_white.png"
            className="register-right-section__logo"
          />
      </section>

        </div>
          </>
       
    )
}

export default Register